export const CLAIM_TYPES = {
    LOSS: 'LOSS',
    DAMAGE: 'DAMAGE',
};